import React from "react"
import PropTypes from 'prop-types'

const Arrow = ({
  style = {},
  fill = "currentColor",
  width = "100%",
  className = "arrow",
  viewBox = "0 0 100 100"
}) => (
  <svg
    width={width}
    style={style}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
  >
    <path fill={fill} d="M65.156 50l-1.969-2.062-24-25-4.343 4.124L56.874 50l-22.03 22.938 4.343 4.125 24-25L65.157 50z" overflow="visible"/>
  </svg>
)

Arrow.propTypes = {
  style: PropTypes.object,
  fill: PropTypes.string,
  width: PropTypes.string,
  className: PropTypes.string,
  viewBox: PropTypes.string
}

export default Arrow
